const CompanyAccess = {
  dashboard: ["zotrai","trawtel", "babaair", "landairtravels", "landair"],
  Visas: ["zotrai","trawtel"],
  flights: ["zotrai","trawtel", "babaair", "landairtravels", "landair"],
  hotels: ["zotrai","trawtel","babaair", "landairtravels", "landair"],
  packages: ["zotrai","trawtel", "babaair", "landairtravels", "landair"],
  sightseeing: ["zotrai","trawtel", "babaair", "landairtravels", "landair"],
  umrah: ["trawtel", "babaair"],
  hajj: ["trawtel", "babaair"],
  marketing: ["zotrai","trawtel", "babaair", "landairtravels", "landair"],
};
export default CompanyAccess;